import { Component, forwardRef, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EntitySearchComponent } from 'app/shared-components/entity-search/entity-search.component';
import { IClientModel } from 'app/common/models/client.model';
import { ClientNameService } from 'app/common/services/client-name.service';
import { ClubSettingService } from 'app/components/club-settings/club-settings.service';

@Component({
    selector: 'app-client-search',
    templateUrl: '../entity-search/entity-search.component.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ClientSearchComponent),
        multi: true
    }]
})
export class ClientSearchComponent extends EntitySearchComponent<IClientModel> {

    public placeholder = 'Телефон или ФИО';
    private clubSettings: any[];
    private clientNameService: ClientNameService;
    private clubSettingService: ClubSettingService;

    constructor(injector: Injector) {
        super(injector);
        this.clientNameService = injector.get(ClientNameService);
        this.clubSettingService = injector.get(ClubSettingService);
    }

    async ngOnInit() {
        super.ngOnInit();
        // Загружаем настройки клуба для правильного порядка имени
        this.clubSettings = await this.clubSettingService.getClubSettingsByClub();
    }

    public niceItemName(item: IClientModel): string {
        if (!this.clubSettings) {
            // Пока настройки не загружены, показываем стандартный порядок
            return `${item.firstName} ${item.lastName}`;
        }
        return this.clientNameService.formatClientName(item, this.clubSettings);
    }

    public findItems(query: string): Promise<IClientModel[]> {
        // TODO: пока просто подменяем id клиента на id пользователя.
        // правильнее сделать отдельный параметр - ключ, и выбрасывать из компонента не всегда id, а свойство с этим ключем
        return this.api.clients.searchClients(this.routingParams, query)
            .then(res => (res.clients as IClientModel[]).map(x => (x.id = x.userId, x)));
    }
}
